<div class="termedUser">
  <div class="msgTitle">
    <span>{{ terminatedUserMessage.title }}</span>
  </div>
  <div class="message">{{ terminatedUserMessage.message }}</div>
</div>
